import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedComponentsModule } from '../shared/shared-components/shared.components.module';
import { DetailPageComponent } from './detail-page.component';
import { DetailPageModeService } from './services/detail-mode.service';
import { DetailPageService } from './services/detail-page.service';

@NgModule({
  declarations: [DetailPageComponent],
  imports: [CommonModule, SharedComponentsModule, TranslateModule],
  providers: [DetailPageService, DetailPageModeService],
  exports: [DetailPageComponent],
})
export class DetailPageModule {}
